<template>
    <div>
        <div class="vfairs-list">
            <div v-for="i in number" :key="i">
                <VFairListItemSkeleton />
            </div>
        </div>
        <Divider />
    </div>
</template>

<script>
// Components
import VFairListItemSkeleton from './VFairListItemSkeleton.vue';

export default {
    name: 'VFairListSkeleton',
    components: {
        VFairListItemSkeleton,
    },
    props: {
        number: {
            type: Number,
            default: 3,
        },
        mini: {
            type: Boolean,
            default: false,
        },
        small: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.vfairs-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 20px;
}
</style>

<style>
.skeleton-loading {
    position: relative;
    overflow: hidden;
}

.skeleton-loading::after {
    display: block;
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    transform: translateX(-100%);

    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.45), transparent);
    animation: skeleton-loading 1.4s infinite;
}

@keyframes skeleton-loading {
    100% {
        transform: translateX(100%);
    }
}
</style>
